import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { TagFilledIcon } from "app/icons/finance";
import { Field, FieldLabel } from "app/components/form/Field/Field";
import { CheckboxField } from "app/components/form/CheckboxField/CheckboxField";

const QuotationBoardFilterOptions = ({ availableBoards, hideDiscountHBX }) => {
	return (
		<fieldset className="quotation-board-filter__options">
			<legend className="sr-only">
				<FormattedMessage id="quotation.board.filter.label" />
			</legend>

			<ul className="quotation-board-filter__options-list">
				{availableBoards.map(board => (
					<li key={board.boardCode} className="quotation-board-filter__option">
						<Field>
							<CheckboxField
								id={`board-filter-${board.boardCode}`}
								name="boards"
								value={board.boardCode}
								data-testid="board-filter"
							/>

							<FieldLabel htmlFor={`board-filter-${board.boardCode}`}>
								<Typography
									variant={TYPOGRAPHY_VARIANTS.REGULAR}
									component="span"
									className="quotation-board-filter__option-label"
								>
									{board.label}
									{board.isDiscounted && !hideDiscountHBX && (
										<>
											<TagFilledIcon
												width={12}
												height={12}
												className="quotation-board-filter__discount-icon"
												aria-hidden="true"
											/>
											<span className="sr-only">
												<FormattedMessage id="quotation.board.discounted" />
											</span>
										</>
									)}
								</Typography>
							</FieldLabel>
						</Field>
					</li>
				))}
			</ul>
		</fieldset>
	);
};

QuotationBoardFilterOptions.propTypes = {
	availableBoards: PropTypes.arrayOf(
		PropTypes.shape({
			boardCode: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			isDiscounted: PropTypes.bool,
		})
	).isRequired,
	setFieldValue: PropTypes.func.isRequired,
	hideDiscountHBX: PropTypes.bool,
};

export default QuotationBoardFilterOptions;
